{
    "SelfProvisioning_ModalTitle": "Add Enterprise Customer",
    "SiteNameLabel": "Company Name:",
    "SiteIndustryVerticalLabel": "Industry Sector:",
    "EnterpriseIDLabel": "Enterprise ID:",
    "UsernameLabel": "Admin Integration Username:",
    "PasswordLabel": "Admin Integration Password:",

    "SelfProvisioning_Help_Username": "**Please be aware:**\n\nWhen entering your BW username, you will need to add unlimitedhorizon.co.uk to your username",

    "SelfProvisioning_DataEntry_Help": "##!##Access the Horizon web portal####Horizon > Horizon Manage Company####Select your reseller account in the Account settings####Choose the action 'Manage Administrators'####Scroll down to the 'Add New Akixi Integration Account' section####For your integration to work, the Akixi User Name must be entered as '[SiteName]Akixi@unlimitedhorizon.co.uk', eg: SmithsPlasticsAkixi@unlimitedhorizon.co.uk####Click the 'Create Admin' button and post the credentials in the section below exactly as they have been sent by Horizon.####!**Please be aware**\nWhen entering your BW username, you will need to add unlimitedhorizon.co.uk to your username",

    "SelfProvisioning_FooterActions_Next": "Next",
    "SelfProvisioning_FooterActions_Connect": "Connect",
    "SelfProvisioning_FooterActions_Cancel": "Cancel",
    "SelfProvisioning_FooterActions_Back": "Try Again",
    "SelfProvisioning_FooterActions_Complete": "Complete",

    "SelfProvisioning_Validation_SiteNameRequired": "Company Name is required",
    "SelfProvisioning_Validation_EnterpriseIDRequired": "Enterprise ID is required",
    "SelfProvisioning_Validation_UsernameRequired": "Username is required",
    "SelfProvisioning_Validation_PasswordRequired": "Password is required",

    "SelfProvisioning_Setup_Info": "Creating customer \"{}\"",

    "SelfProvisioning_EntityTS_Label": "Telephony Server",
    "SelfProvisioning_EntityP_Label": "Partition",

    "SelfProvisioning_ID_Label": "ID:",
    "SelfProvisioning_No_Label": "No:",
    "SelfProvisioning_Count_Label": "Count:",

    "SelfProvisioning_StatusMessage_TelSys_WAITING": "Creating...",
    "SelfProvisioning_StatusMessage_TelSys_CREATED": "Connecting...",
    "SelfProvisioning_StatusMessage_TelSys_SYNCED": "Completed",
    "SelfProvisioning_StatusMessage_TelSys_FAILED": "Failed",

    "SelfProvisioning_StatusMessage_Partition_WAITING": "Creating...",
    "SelfProvisioning_StatusMessage_Partition_CREATED": "Syncing...",
    "SelfProvisioning_StatusMessage_Partition_SYNCED": "Completed",
    "SelfProvisioning_StatusMessage_Partition_FAILED": "Failed",

    "SelfProvisioning_SyncSumary_Info": "Extension/Endpoints",

    "SelfProvisioning_Error_SyncFailed": "Something went wrong with the sync, please check your Username, Password and Enterprise ID and try again. Please note that if your password was entered incorrectly you may now be locked out of the Telephony System. Please contact your support in order to unlock your account.",

    "SelfProvisioning_Users_Title": "Create Reporting Users",

    "SelfProvisioning_Users_UserType_ReportingSupervisor": "Enterprise Reporting User",
    "SelfProvisioning_Users_UserType_OneUser": "ONE User",

    "SelfProvisioning_Users_UserType_Label": "User Type",
    "SelfProvisioning_Users_Email_Label": "Email",
    "SelfProvisioning_Users_Name_Label": "Extension/Name",
    "SelfProvisioning_Users_WelcomeEmail_Label": "Welcome Email",

    "SelfProvisioning_Users_Devices_None": "None",

    "SelfProvisioning_Users_Validation_DeviceNumber": "A device must be selected.",
    "SelfProvisioning_Users_Validation_Name": "Extension/Name is required.",
    "SelfProvisioning_Users_Validation_Email": "Email address is required.",

    "Industries_Construction_Manufacturing": "Construction & Manufacturing",
    "Industries_Education": "Education",
    "Industries_Financial_Services": "Financial Services",
    "Industries_IT": "Information Technology",
    "Industries_Healthcare": "Healthcare",
    "Industries_Hospitality": "Hospitality",
    "Industries_Legal_Professional_Services": "Legal and Professional Services",
    "Industries_Non_Profit": "Non-Profit",
    "Industries_Retail": "Retail",
    "Industries_Transport_Logistics": "Transport and Logistics",
    "Industries_Other": "Other",

    "SelfProvisioning_ExitPrompt_Message": "Are you sure you want to exit the wizard, this will mean that anything you have created so far will be deleted.",
    "SelfProvisioning_ExitPrompt_Confirm": "Confirm",
    "SelfProvisioning_ExitPrompt_Cancel": "Cancel",

    "SelfProvisioning_Welcome_Para_1": "Welcome to the Enterprise Provisioning Wizard.\n\nThis wizard will guide you through the setup of a new Enterprise company. This {(http://gamma-Enterprise.akixi.com)video link} gives you a run through of the wizard.\n\nTo continue with this wizard the below details are required:",
    "SelfProvisioning_Welcome_Para_2": "##!##Enterprise ID####Akixi Integration Username and Password####!",
    "SelfProvisioning_Welcome_Para_3": "During this wizard you will be asked to:\n\n##!##Enter site information and credentials for the Akixi Enterprise service to be created####Create Reporting User accounts####Confirm Site details and complete the setup prerequisites####!",
    "SelfProvisioning_Welcome_Para_4": "Click Next to continue. To abort the setup, click Cancel at any time. Closing your browser or tab will not cancel the provisioning process. Should this occur, please contact our Support team on {(mailto:support@akixi.com)support@akixi.com}.",

    "SelfProvisioning_Welcome_Help": "**How to obtain your Prerequisites**\n\n##!##Access the Horizon web portal####Log in to the Horizon web portal, which shows the general information page (Latest News, etc.)####From the horizontal menu bar, choose: Login > General Info (Latest News) > Provisioning And Service Management > Hosted > Horizon > Horizon Manage Company####Select your reseller account in the 'Account' setting####Under 'Results', choose the action 'Manage Administrators'####At the bottom of the page: Scroll down to the 'Add New Akixi Integration Account' section####For your integration to work, the Akixi User Name must be entered as '[SiteName]Akixi@unlimitedhorizon.co.uk', eg: SmithsPlasticsAkixi@unlimitedhorizon.co.uk####Click the 'Create Admin' button and Akixi Admin User / Akixi Integration Account notification email will be sent####!",

    "SelfProvisioning_ReviewView_Title": "Enterprise Company Summary:",
    "SelfProvisioning_ReviewView_CustomerReference_Label": "Customer Reference:",
    "SelfProvisioning_ReviewView_CustomerReference_Validation": "Customer Reference is required",
    "SelfProvisioning_ReviewView_ConfirmationText": "By clicking **complete**, you accept a live chargeable company will now be created and the **Akixi Service Agreement**",

    "SelfProvisioning_ReviewView_Table_TelSys": "Telephony Server ID",
    "SelfProvisioning_ReviewView_Table_Partition": "Partition ID",
    "SelfProvisioning_ReviewView_Table_DeviceCount": "Extension Endpoints",
    "SelfProvisioning_ReviewView_Table_UserCount": "Reporting Users",

    "SelfProvisioning_CompletedView_Title": "Success! Your new Akixi Enterprise customer has been created within your CME.",
    "SelfProvisioning_CompletedView_SentTo": "Confirmation sent to: {}",
    "SelfProvisioning_CompletedView_Close": "Close",

    "SelfProvisioning_Errors_SessionNotFound": "Session not found",

    "NAME": "SelfProvisioning"
}